const catalogueActions = {
  DOWNLOAD_CATALOGUE: 'DOWNLOAD_CATALOGUE',
  DOWNLOAD_CATALOGUE_ERROR: 'DOWNLOAD_CATALOGUE_ERROR',
  FETCH_CATALOGUE: 'FETCH_CATALOGUE',
  SHOW_CATALOGUE: 'SHOW_CATALOGUE',
  SHOW_CATALOGUE_ERROR: 'SHOW_CATALOGUE_ERROR',
};

export const catalogueCategories = ['open'];

export default catalogueActions;
